import React, { Component } from 'react';
import Section from './Section'
import Header from './Header'
import { Helmet } from "react-helmet"
import WOW from 'wowjs'

class Home extends Component {

	componentDidMount() {
		new WOW.WOW({ mobile: false, }).init();
		window.scrollTo(0,0);
	}
	
	render() {
		return (
			<div>
				<Helmet>
					<title>Moshi Moshi Marketing - Website Design | Logo and Branding | Google Ads | Bunbury | Belmont | Perth</title>
					<meta name="description" content="Business marketing specialists, bringing data and design together to develop effective websites and mobile apps.  Specialists in Google Ads and social media management, as well as graphic design including logo creation, business card design and brochures." />
                </Helmet>  
				
				<Header />
				<Section
					top
					bottom
					to="/blog/Covid-19-marketing-tools"
					id="section-4"
					home="scroll-to-section-4"
					image={require('./image-2.jpg')}
					titleLine1="where data meets design"
					titleLine2="to optimise your business"
					desc="Data sets apart today’s business world from yesterday’s. Bringing together data, strategy and design levels the playing field, providing effective and measurable marketing tools to connect you with your customer."
					list={[
						'Google Ads', 'SEO', 'Social Media Marketing', 'Brand and Logo Design', 'Graphic Design', 'Content Writing'
					]}
					circle={{
						title1: "Covid-19",
						title2: "Marketing Tools",
						desc: "Marketing",
						month: "20 May",
						year: "2020",
						theme: "primary",
					}}
				/>
				
				<Section
					bottom
					to="/blog/understanding-consumer-behaviour"
					theme="dark"
					id="section-1"
					home="scroll-to-section-1"
					image={require('./Blog-1.jpg')}
					titleLine1="helping clarify and define"
					titleLine2="your business and target market"
					desc="Moshi works with businesses to understand their place in the community through a problem-focused ‘process analysis’. From here, your brand and services can be tailored to maximise value to your customers while maximising your customer’s value to your business."
					list={[
						 'Brand and Logo Design', 'Social Media Management', 'Email Newsletter Marketing', 'Photography and Video', 'Video Production'
					]}
					circle={{
						title1: "Consumer Behaviour",
						title2: "in Marketing and Design",
						desc: "Graphic Design",
						month: "07 May",
						year: "2020",
						theme: "secondary",
					}}
				/>
				<Section
					bottom
					to="/blog/combining-ux-and-ui-to-create-converting-websites"
					theme="green"
					id="section-3"
					home="scroll-to-section-3"
					image={require('./blog-2.jpg')}
					titleLine1="giving business access to the"
					titleLine2="latest development technologies"
					desc="Our user-focused design is brought to life by our expert development team building state-of-the-art websites, mobile applications, or commercial and industrial software. Being results-driven, our work aims to either increase conversions or engagement or save time through streamlining processes."
					list={[
						'Website Development', 'App Development', 'ecommerce / online shops', 'Custom Programmed Systems', 'Website Hosting', 'Domain Address Registration',
					]}
					circle={{
						title1: "Combining UX and UI",
						title2: "To Create Converting Websites",
						desc: "Web Development",
						month: "11 May",
						year: "2020",
						theme: "primary-1",
					}}
				/>
				<div style={{height:240 }} />
			</div>
		);
	}
}

export default Home;




// WEBPACK FOOTER //
// ./src/Pages/Home/Home.js